export const VOICE_MAIL = 'Voicemail';
const VOICE_MAIL_DROP = 'VoicemailDrop';

export const AUDIO_RECORDING_TYPES = [
  { name: 'Voicemail Drop', value: VOICE_MAIL_DROP },
  { name: 'Voicemail', value: VOICE_MAIL },
];
